import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, ContactBlock } from "@/sections";

export default function ContactPage() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/site-content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="Contact"
        title="Find me here."
        subtitle="Send a message, or reach out directly via email or social. Studio in Waitetuna, Raglan, Aotearoa New Zealand."
      />
      <ContactBlock content={content} />
      <Footer content={content || {}} />
    </div>
  );
}
